import { useCallback } from 'react'
import { useReactiveVar } from '@apollo/client'
import { clientInfo } from '../../common/graphql/cache'
import { Customer } from '../../common/graphql/__generated__/graphql.autogenerated'

type SetCustomerInformationType = (customerInformation?: Customer) => void
type CustomerInformationReturnType = [
  customerInformation: Customer,
  setCustomerInformation: SetCustomerInformationType
]

const useCustomerInformation = (): CustomerInformationReturnType => {
  const customerInformation = useReactiveVar(clientInfo)

  const setCustomerInformation: SetCustomerInformationType = useCallback(
    customerInformation => {
      clientInfo(customerInformation)
    },
    [clientInfo]
  )

  return [customerInformation, setCustomerInformation]
}

export default useCustomerInformation
